import { Box, Select, TextField } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useState, useEffect } from "react";
import ReasonType from "@warriortrading/warriortrading.hermes.common.feathers/enums/reasonType";

export const CommonReasonsEdit = () => {
  const {
    saveButtonProps,
    refineCore: { queryResult },
    register,
    formState: { errors },
  } = useForm();
  const data = queryResult?.data?.data;
  const [value, setValue] = useState("");
  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value as string);
  };
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [sortNo, setSortNo] = useState("");
  useEffect(() => {
    if (data) {
      setValue(data?.reasonType);
      if (data?.createdAt) {
        setCreatedAt(new Date(data?.createdAt).toLocaleString());
      }
      if (data?.updatedAt) {
        setUpdatedAt(new Date(data?.updatedAt).toLocaleString());
      }
      setSortNo(data?.sortNo);
    }
  }, [data]);
  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("code", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.code}
          helperText={(errors as any)?.code?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Code"
          name="code"
        />
        <FormControl
          fullWidth
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          <InputLabel id="reasonType">ReasonType</InputLabel>
          <Select
            {...register("reasonType", {})}
            labelId="reasonType"
            value={value}
            label="ReasonType"
            onChange={handleChange}
          >
            {Object.values(ReasonType)[1]
              .filter((item: any) => item.value !== ReasonType.MOVE.value)
              .map((item: any) => {
                return (
                  <MenuItem key={item.value} value={item.value}>
                    {item.name}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
        <TextField
          {...register("content", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.content}
          helperText={(errors as any)?.content?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Content"
          name="content"
        />
        <TextField
          {...register("sortNo", {
            required: "This field is required",
            validate: () => {
              var intRegex = /^-?\d+$/;
              return intRegex.test(sortNo);
            },
          })}
          error={!!(errors as any)?.sortNo}
          helperText={"SortNo cannot be null and sortNo must be integer!"}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="SortNo"
          name="sortNo"
          value={sortNo}
          onChange={(e) => {
            setSortNo(e.target.value);
          }}
        />
        <TextField
          error={!!(errors as any)?.createdAt}
          helperText={(errors as any)?.createdAt?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="CreatedAt"
          name="createdAt"
          value={createdAt}
          disabled
        />
        <TextField
          error={!!(errors as any)?.updatedAt}
          helperText={(errors as any)?.updatedAt?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="UpdatedAt"
          name="updatedAt"
          value={updatedAt}
          disabled
        />
        <TextField
          {...register("name", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />
      </Box>
    </Edit>
  );
};
